module.exports = __webpack_public_path__ + "static/media/pp2.9ced823e.png";